import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsFloat,
  parseAsString,
} from "nuqs/server";

/**
 * The whitelist is split by which country's catalog serves each facet, so the
 * origin of a key is stated once, here, instead of being implicit in a flat
 * list. `PendingFilters` and its per-country variants are derived from these
 * three groups (see `../types/filters.type`), which keeps the type from
 * drifting away from the parsers — they used to be two hand-kept lists.
 *
 * The split follows the CO facet seed (search-api CO-SA-2): what CO serves and
 * BR also serves is shared; what is only in the BR whitelist is BR; the five
 * keys CO added are CO.
 *
 * The runtime object stays flat and complete on purpose: reading a param the
 * current country does not serve is inert (the facet simply is not rendered),
 * and scoping the request by country is a separate change — it has to reach
 * `useFilterParams`, `getCatalogFilterParams` and the store to mean anything.
 */
const sharedFilterParsers = {
  gender: parseAsArrayOf(parseAsString),
  brand: parseAsArrayOf(parseAsString),
  color: parseAsArrayOf(parseAsString),
  categories_ids: parseAsArrayOf(parseAsString),
  fit: parseAsArrayOf(parseAsString),
  price_min: parseAsFloat,
  price_max: parseAsFloat,
} as const;

const brFilterParsers = {
  size: parseAsArrayOf(parseAsString),
  seller: parseAsArrayOf(parseAsString),
  owner: parseAsArrayOf(parseAsString),
  character: parseAsArrayOf(parseAsString),
  heel_height: parseAsArrayOf(parseAsString),
  heel_shape: parseAsArrayOf(parseAsString),
  shaft_height: parseAsArrayOf(parseAsString),
  tip_shape: parseAsArrayOf(parseAsString),
  closing: parseAsArrayOf(parseAsString),
  clothes_material: parseAsArrayOf(parseAsString),
  print: parseAsArrayOf(parseAsString),
  length: parseAsArrayOf(parseAsString),
  sleeve: parseAsArrayOf(parseAsString),
  waist: parseAsArrayOf(parseAsString),
  enable_free_shipping: parseAsBoolean,
  shipping_type: parseAsBoolean,
} as const;

/** Size is split by product type, mirroring the app. */
const coFilterParsers = {
  shoe_size: parseAsArrayOf(parseAsString),
  app_topsize: parseAsArrayOf(parseAsString),
  appbottom_size: parseAsArrayOf(parseAsString),
  acc_size: parseAsArrayOf(parseAsString),
  moda_sostenible: parseAsArrayOf(parseAsString),
} as const;

export const filterParsers = {
  ...sharedFilterParsers,
  ...brFilterParsers,
  ...coFilterParsers,
} as const;

export type SharedFilterParsers = typeof sharedFilterParsers;
export type BrFilterParsers = typeof brFilterParsers;
export type CoFilterParsers = typeof coFilterParsers;

export type FilterParamKey = keyof typeof filterParsers;
